<template>
  <div style="display: flex;justify-content: center;align-items: center;height: calc(100vh - 84px)">
    <a-button @click="jumpRouter">跳转到发货需求</a-button>
  </div>
</template>
<script>
export default {
  // eslint-disable-next-line
  name: 'Delivery-demand-list', // name要和rms配置菜单路由保存一致(首字母大写)
  methods: {
    jumpRouter() {
      const url = process.env.VUE_APP_API_LSCM_URL + '/#/purchase-execute/receive-deliver-goods/delivery-demand-list'
      window.open(url, '_blank')
    }
  },
  created () {
    this.jumpRouter()
  }
}
</script>
